import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from "vanilla-cookieconsent";
import './cookieconsent.scss';

const isHttps = window.location.protocol === "https:";

const cookieConfig = {
  cookie: {
    httpOnly: true,
    secure: isHttps,
    sameSite: isHttps ? "None" : "Lax"
  },

  disablePageInteraction: false,
  guiOptions: {
    consentModal: {
      layout: "cloud",
      position: "bottom center",
      equalWeightButtons: false,
      flipButtons: false
    },
    preferencesModal: {
      layout: "box",
      position: "right"
    }
  },
  

  categories: {
    necessary: {
      enabled: true,
      readOnly: true
    },
    performance: { enabled: false },
    functional: { enabled: false },
    targeting: { enabled: false }
  },

  language: {
    default: "en",
    translations: {
      en: {
        consentModal: {
          // title: "We respect your privacy",
          description: "We use cookies to enhance your experience — some are essential, others help us improve performance and personalize content. You can accept all cookies, reject non‑essential cookies, or manage your preferences.",
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Reject all",
          showPreferencesBtn: "Manage preferences"
        },
        preferencesModal: {
          title: "Preference Center",
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Reject all",
          savePreferencesBtn: "Save My Preferences",
        
          sections: [
            // 🔹 Preference Center description block
            {
              title: "",
              description: `
                <div class="cc-pc-description">
                 Cookies are small text files stored on your device when you visit a website. They help the site remember your preferences, improve functionality, and provide a better user experience. Some cookies are mandatory (strictly necessary) for the site to work properly and cannot be turned off.
                </div>
              `
            },
            {
              title: "Strictly Necessary Cookies",
              linkedCategory: "necessary",
              description: `  <ul class="cc-bullets">
    <li>These are the essential cookies required for the website to function.</li>
    <li>They ensure pages load correctly and secure areas work.</li>
    <li>They are set in response to your actions such as logging in or filling forms.</li>
    <li>They do not store any personally identifiable information.</li>
    <li><strong>You cannot turn these cookies off.</strong></li>
  </ul>

              `
            },
            {
              title: "Performance Cookies",
              linkedCategory: "performance",
              description: `
<ul class="cc-bullets">
    <li>They track how visitors use the website (popular pages, errors, traffic sources).</li>
    <li>They help us improve website speed and performance.</li>
    <li>All data collected is aggregated and anonymous.</li>
    <li>No personal information is stored.</li>
    <li>You can choose to disable these cookies.</li>
  </ul>
              `
            },
            {
              title: "Functional Cookies",
              linkedCategory: "functional",
              description: `
  <ul class="cc-bullets">
    <li>They remember your preferences such as language, region, or login details.</li>
    <li>They provide enhanced and personalized website features.</li>
    <li>If disabled, some features may not work correctly.</li>
    <li>You may need to re-enter your settings each time you visit.</li>
    <li>You can choose to disable these cookies.</li>
  </ul>
              `
            },
            {
              title: "Targeting Cookies",
              linkedCategory: "targeting",
              description: `
  <ul class="cc-bullets">
    <li>They are used to show advertisements relevant to your interests.</li>
    <li>They may be set by our advertising partners.</li>
    <li>They build a profile based on your browser and device.</li>
    <li>They help limit how often you see the same advertisement.</li>
    <li>If disabled, you will still see ads but they may be less relevant.</li>
    <li>You can choose to disable these cookies.</li>
  </ul>`

            }
          ]
        }
      }
    }
  }
};

export const initCookieConsent = () => {
  CookieConsent.run(cookieConfig);

  const handleConsentUpdate = () => {
    const performance = CookieConsent.acceptedCategory("performance");
    const functional  = CookieConsent.acceptedCategory("functional");
    const targeting   = CookieConsent.acceptedCategory("targeting");

    console.log("Performance:", performance);
    console.log("Functional:", functional);
    console.log("Targeting:", targeting);

    if (performance) enableAnalytics();
    if (functional) enableFunctionalServices();
    if (targeting) enableAdsTracking();
  };

  window.addEventListener("cc:onConsent", handleConsentUpdate);
  window.addEventListener("cc:onChange", handleConsentUpdate);
};

const enableAnalytics = () => console.log("Analytics Enabled");
const enableFunctionalServices = () => console.log("Functional Enabled");
const enableAdsTracking = () => console.log("Ads Enabled");

export default cookieConfig;
